import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useCustomerAuth } from '../../context/CustomerAuthContext';
import './Auth.css';

const CustomerLogin = () => {
  const navigate = useNavigate();
  const { login, isAuthenticated, getSignInWithMangoUrl } = useCustomerAuth();

  useEffect(() => {
    if (isAuthenticated) navigate('/customer/profile');
  }, [isAuthenticated, navigate]);
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      await login(formData.email, formData.password);
      navigate('/customer/profile');
    } catch (err) {
      setError(err.message || 'Login failed. Please check your credentials.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h1>Log In</h1>
        <p className="auth-subtitle">Welcome back! Sign in to your account</p>

        {error && <div className="error-message">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Password</label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
            />
          </div>

          <button type="submit" className="auth-button" disabled={isLoading}>
            {isLoading ? 'Logging in...' : 'Log In'}
          </button>

          <div style={{ marginTop: 16, textAlign: 'center' }}>
            <span style={{ fontSize: 14, color: '#666' }}>or</span>
            <a
              href={getSignInWithMangoUrl()}
              style={{
                display: 'block',
                marginTop: 10,
                padding: '12px',
                background: 'linear-gradient(135deg, #ff9a56 0%, #ff6b35 100%)',
                color: 'white',
                borderRadius: 8,
                textDecoration: 'none',
                fontWeight: 600,
                fontSize: 15,
              }}
            >
              Sign in with Mango
            </a>
            <p style={{ marginTop: 10, fontSize: 12, color: '#888' }}>
              Use your Mango ID or email once; sign in on any business without re-entering.
            </p>
          </div>
        </form>

        <p className="auth-footer">
          Don't have an account? <Link to="/customer/signup">Sign up</Link>
        </p>
      </div>
    </div>
  );
};

export default CustomerLogin;

